import * as Sentry from '@sentry/nextjs';

import {
  EventPayoutDestination,
  PayoutBank as PayoutBankDto
} from 'legacy/events/types';

import getBankByStripeId from './getBankByStripeId';

function retrieveDefaultCurrentSelection(
  payoutDestination: EventPayoutDestination,
  banks: {
    hostBanks: PayoutBankDto[];
    associationsBanks: PayoutBankDto[];
  },
  eventId: string
) {
  if (!payoutDestination) {
    return null;
  }

  const initialDestination = getBankByStripeId(
    banks,
    payoutDestination.stripeId
  );

  if (!initialDestination) {
    Sentry.captureMessage(
      `Event payout destination ${payoutDestination.stripeId} is not available for event ${eventId}. Please check with the event host to set an available payout destination`,
      { level: 'warning' }
    );
    return null;
  }

  return initialDestination;
}

export default retrieveDefaultCurrentSelection;
